import { decodeJwt } from 'jose';

/** Access token claim the API sets for accounts in a remote support group. */
const REMOTE_SUPPORT_CLAIM = 'remoteSupport';

/**
 * Whether the access token opens the remote support page and shows its menu entry.
 *
 * @remarks
 * Only decides what the interface shows: the API checks the support groups again on every connect.
 * The claim is written at sign-in and on each token refresh, so adding an account to a group, or
 * removing it, shows from its next token.
 */
export function canProvideRemoteSupport(token: string | null): boolean {
  if (!token) {
    return false;
  }
  try {
    return decodeJwt(token)[REMOTE_SUPPORT_CLAIM] === true;
  } catch {
    return false;
  }
}
